import Storage from "$src/core/services/storage/storage";
import wait from "$src/core/utils/async/wait";

// For now just in local storage
// TODO: Implement this in the backend
const addWatchlistItem = async (
  profileId: string,
  id: string,
): Promise<void> => {
  const watchlist = Storage.get("watchlist") ?? {};
  watchlist[profileId] = [...(watchlist[profileId] ?? []), id];
  Storage.set("watchlist", watchlist);

  // Simulate wait
  await wait(400);
};

export default addWatchlistItem;
